import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '@env/environment';

type InputAttrs = { [prop: string]: string };
interface ScriptDef {
  src?: string;
  body?: string;
  async?: boolean;
  attrs?: InputAttrs;
}

/**
 * AppInitService is responsible of configuring all required settings before considering app 'initialized'.
 *
 * Consider setting up:
 *   - Branding
 *   - ...
 */
@Injectable()
export class AppInitService {
  constructor() {} //private branding: Branding

  // public init(): Promise<any> {
  //   return Promise.all([this.initBranding(), this.initCookieAlert()]);
  // }

  protected async initBranding(): Promise<void> {}

  /**
   * Load proper Cookielaw scripts based on brand specific settings in current environment
   *
   * @returns void
   */
  // protected async initCookieAlert(): Promise<void> {
  //   return new Promise((resolve, reject) => {
  //     this.branding
  //       .brand()
  //       .pipe(
  //         catchError((error) => {
  //           reject(error);
  //           return of(error);
  //         })
  //       )
  //       .subscribe((brandCode) => {
  //         // Get brand seetings
  //         const brand = this.branding.findBrandByNameOrCode(brandCode);
  //         const { cookielawDomainScript } = brand.props;

  //         // Load scripts using domain script
  //         this.loadScript(`https://cdn.cookielaw.org/consent/${cookielawDomainScript}/OtAutoBlock.js`);
  //         this.loadScript({
  //           src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
  //           attrs: { 'data-domain-script': cookielawDomainScript },
  //         });
  //         this.loadScript({ body: 'function OptanonWrapper() { }' });

  //         resolve();
  //       });
  //   });
  // }

  private loadScript(script: string | ScriptDef) {
    let src: string;
    let body: string;
    let attrs: InputAttrs;
    let isAsync = true;
    let charset = 'utf-8';
    const node = document.createElement('script');
    if (typeof script === 'string') {
      src = script;
    } else {
      isAsync = script.async ?? isAsync;
      src = script.src ?? src;
      body = script.body ?? body;
      attrs = script.attrs ?? attrs;
    }
    if (src) {
      node.src = src;
    }
    if (body) {
      node.innerText = body;
    }
    if (isAsync) {
      node.async = isAsync;
    }
    if (attrs) {
      // Custom properties
      Object.entries(attrs).forEach(([propName, propValue]) => {
        node.setAttribute(propName, propValue);
      });
    }
    node.charset = charset;
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(node);
  }
}
